import { render, staticRenderFns } from "./ALPage.vue?vue&type=template&id=1a9e89e5&"
import script from "./ALPage.vue?vue&type=script&lang=ts&"
export * from "./ALPage.vue?vue&type=script&lang=ts&"
import style0 from "./ALPage.vue?vue&type=style&index=0&id=1a9e89e5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports